import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NETWORK } from '@arianee/arianeejs/dist/src';
import { HttpClient } from '@angular/common/http';
import { ArianeeService } from '../arianee-service/arianee.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ArianeeCustodialService {
  constructor (
      private http: HttpClient,
      private arianeeService:ArianeeService
  ) { }

  public async exportArianeeCustodialToMnemonic (jwtAuth: string, pubKey: JsonWebKey, network: NETWORK): Promise<any> {
    if (network === 'arianeetestnet') {
      network = NETWORK.testnet;
    }
    const url = environment.arianeeCustodial.url.replace(':network', network);

    return this.http.post(url + '/wallet/export/',
      { pubKey: pubKey },
      {
        headers: {
          authorization: `Bearer ${jwtAuth}`
        }
      }).pipe(take(1)).toPromise();
  }

  public async exportMnemonicToArianeeCustodial (jwtAuth:string, mnemonic:string, network: NETWORK):Promise<any> {
    if (network === 'arianeetestnet') {
      network = NETWORK.testnet;
    }
    const url = environment.arianeeCustodial.url.replace(':network', network);

    return this.http.post(url + '/wallet/create', {
      mnemonic: mnemonic
    }, {
      headers: {
        authorization: `Bearer ${jwtAuth}`
      }
    }).pipe(take(1)).toPromise();
  }
}
